export const dev = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: '6RB6hhma0jNRgPVJxwFvfXTUe1BITilA',
        audience: 'https://crew-time/api',
    }
}

export const prod = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: '6RB6hhma0jNRgPVJxwFvfXTUe1BITilA',
        audience: 'https://crew-time/api',
    }
}